import { tsValidateArray, tsValidateString, tsValidateValue } from '@nu-art/ts-common';
import { smartDocStaticParamType_MDM, smartDocStaticParamType_MDM_ConsiderationGroups, smartDocStaticParamType_MDM_ProtocolStatus, smartDocStaticParamType_MDM_ProtocolTypes } from './types.js';
import { Validator_SmartDocStaticParamType } from '../_base/index.js';
import { Validator_SmartDocParamResolver_MDM } from '../../../smart-doc-param-resolver/index.js';
export const Validator_SmartDocStaticParam_MDM = {
    key: tsValidateString(),
    type: Validator_SmartDocStaticParamType,
    subType: tsValidateValue([smartDocStaticParamType_MDM]),
    protocolType: tsValidateArray(tsValidateValue([...smartDocStaticParamType_MDM_ProtocolTypes])),
    protocolConsiderationGroup: tsValidateArray(tsValidateValue([...smartDocStaticParamType_MDM_ConsiderationGroups])),
    protocolStatus: tsValidateArray(tsValidateValue([...smartDocStaticParamType_MDM_ProtocolStatus])),
    resolver: Validator_SmartDocParamResolver_MDM,
};
//# sourceMappingURL=validator.js.map